var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as dashboardAction from '../actions/dashboard.action';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { DashboardService } from '../../dashboard.service';
var DashboardEffett = /** @class */ (function () {
    function DashboardEffett(actions, dashboardService, store) {
        var _this = this;
        this.actions = actions;
        this.dashboardService = dashboardService;
        this.store = store;
        this.getDashboardDetails = this.actions.ofType(dashboardAction.GET_DASHBOARD_DETAILS)
            .map(function (action) { return action.payload; })
            .pipe(mergeMap(function (body) {
            return _this.dashboardService.getDashboardDetails(body)
                .map(function (res) { return new dashboardAction.GetDashboardDetailsSuccess(res); })
                .catch(function (error) { return of(new dashboardAction.GetDashboardDetailsError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], DashboardEffett.prototype, "getDashboardDetails", void 0);
    return DashboardEffett;
}());
export { DashboardEffett };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/effects/dashboard.effect.ts.pre-build-optimizer.js